var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPauseBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 148,
    viewBox: "0 0 147 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.360352 10C0.360352 4.47717 4.8375 0 10.3604 0H136.36C141.883 0 146.36 4.47715 146.36 10V137.973C146.36 143.496 141.883 147.973 136.36 147.973H10.3603C4.8375 147.973 0.360352 143.496 0.360352 137.973V10Z",
    fill: "#0164FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7077 27.9881C86.5816 27.9684 85.4618 28.1089 84.4191 28.4007C83.3765 28.6924 82.4337 29.1291 81.6503 29.683C80.867 30.237 80.2603 30.8962 79.8685 31.6189C79.4767 32.3416 79.3084 33.1121 79.3743 33.8816V115.103C79.071 122.947 96.6597 122.947 96.3565 115.103V33.8816C96.3605 33.1048 96.1393 32.3351 95.7056 31.6172C95.272 30.8993 94.6345 30.2474 93.8301 29.6993C93.0257 29.1512 92.0704 28.7177 91.0194 28.424C89.9685 28.1302 88.8429 27.9821 87.7077 27.9881Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7077 27.9881C57.5816 27.9684 56.4618 28.1089 55.4191 28.4007C54.3765 28.6924 53.4337 29.1291 52.6503 29.683C51.867 30.237 51.2603 30.8962 50.8685 31.6189C50.4767 32.3416 50.3084 33.1121 50.3743 33.8816V115.103C50.071 122.947 67.6597 122.947 67.3565 115.103V33.8816C67.3605 33.1048 67.1393 32.3351 66.7056 31.6172C66.272 30.8993 65.6345 30.2474 64.8301 29.6993C64.0257 29.1512 63.0704 28.7177 62.0194 28.424C60.9685 28.1302 59.8429 27.9821 58.7077 27.9881Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseBtn);
export default __webpack_public_path__ + "static/media/pause_btn.97c97944.svg";
export { ForwardRef as ReactComponent };